import { forwardRef } from 'react';

import {
  TableCell,
  TableCellProps,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';

import { DateUtils } from '@spotify/confidence-core-react';

interface UpdateCellProps extends TableCellProps {
  updateTime: string;
}

export const UpdateCell = forwardRef<HTMLTableCellElement, UpdateCellProps>(
  ({ updateTime, ...props }, ref) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
      <TableCell {...props} ref={ref}>
        {isSmallScreen
          ? DateUtils.xAgoShort(new Date(updateTime))
          : DateUtils.xAgo(new Date(updateTime))}
      </TableCell>
    );
  },
);
UpdateCell.displayName = 'UpdateCell';
